import { useEffect } from "react";

/**
 * Hook to monitor component render performance
 * Logs warnings for renders taking longer than threshold
 * @param componentName - Name of the component being monitored
 * @param threshold - Performance threshold in ms (default: 100ms)
 */
export function usePerformanceMonitor(
  componentName: string,
  threshold: number = 100
) {
  useEffect(() => {
    const startTime = performance.now();

    return () => {
      const endTime = performance.now();
      const renderTime = endTime - startTime;

      if (renderTime > threshold) {
        console.warn(
          `⚠️ ${componentName} took ${renderTime.toFixed(2)}ms to render`
        );
      }
    };
  });
}
